import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { BrandProvider } from "@/context/BrandContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import Overview from "@/pages/Overview";
import AgentConsole from "@/pages/AgentConsole";
import AuthorizationDesigner from "@/pages/AuthorizationDesigner";
import BuyerResolver from "@/pages/BuyerResolver";
import OrderRouting from "@/pages/OrderRouting";
import Offers from "@/pages/Offers";
import Renewals from "@/pages/Renewals";
import Integrations from "@/pages/Integrations";
import CPRegistration from "@/pages/CPRegistration";
import RateCards from "@/pages/RateCards";
import Login from "@/pages/Login";
import Workspace from "@/pages/Workspace";
import TraceAudit from "@/pages/TraceAudit";
import Verify from "@/pages/Verify";
import Handoff from "@/pages/Handoff";
import DealDetail from "@/pages/DealDetail";
import Playbooks from "@/pages/Playbooks";
import SsoLanding from "@/pages/SsoLanding";

function App() {
  return (
    <div className="App">
      <BrandProvider>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/verify" element={<Verify />} />
            <Route path="/sso" element={<SsoLanding />} />
            <Route element={<ProtectedRoute />}>
              <Route element={<Layout />}>
                <Route path="/" element={<Overview />} />
                <Route path="/agent" element={<AgentConsole />} />
                <Route path="/designer" element={<AuthorizationDesigner />} />
                <Route path="/buyer" element={<BuyerResolver />} />
                <Route path="/routing" element={<OrderRouting />} />
                <Route path="/offers" element={<Offers />} />
                <Route path="/rate-cards" element={<RateCards />} />
                <Route path="/renewals" element={<Renewals />} />
                <Route path="/audit" element={<TraceAudit />} />
                <Route path="/handoff" element={<Handoff />} />
                <Route path="/handoff/:dealId" element={<DealDetail />} />
                <Route path="/playbooks" element={<Playbooks />} />
                <Route path="/integrations" element={<Integrations />} />
                <Route path="/cp-registration" element={<CPRegistration />} />
                <Route path="/workspace" element={<Workspace />} />
              </Route>
            </Route>
          </Routes>
        </BrowserRouter>
      </AuthProvider>
      </BrandProvider>
      <Toaster
        theme="light"
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#ffffff",
            border: "1px solid #e4e4e7",
            color: "#18181b",
            fontFamily: "IBM Plex Sans, sans-serif",
          },
        }}
      />
    </div>
  );
}

export default App;
